var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoldLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30.5,
    fill: "#FFF4E2",
    stroke: "#FFB82F",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.896 21.89C34.132 24.958 38.474 28.468 42.452 30.574C43.024 29.612 43.752 28.546 44.506 27.766C40.372 26.076 36.186 22.8 33.378 18.848H30.128C28.204 21.994 24.018 25.894 19.546 28.078C20.222 28.728 21.106 29.872 21.496 30.6C25.76 28.338 29.738 24.932 31.896 21.89ZM25.37 26.726V29.456H38.474V26.726H25.37ZM22.276 32.03V34.708H41.542V32.03H22.276ZM20.95 39.934V42.612H43.05V39.934H20.95ZM30.18 27.818V41.26H33.508V27.818H30.18ZM23.888 35.696C24.824 37.074 25.786 38.972 26.124 40.168L28.828 38.998C28.438 37.776 27.398 35.982 26.41 34.656L23.888 35.696ZM37.122 34.682C36.55 36.086 35.458 37.984 34.626 39.206L36.966 40.168C37.876 39.076 39.02 37.386 40.086 35.8L37.122 34.682Z",
    fill: "#FFB82F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldLevel);
export default __webpack_public_path__ + "static/media/gold_level.44b878beac623684e861048ef9c096e3.svg";
export { ForwardRef as ReactComponent };